
import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface SlideSettingsProps {
  pages: Array<any>; // Replace with proper type from your app
  setPages: (pages: Array<any>) => void;
  onEditPage: (pageId: string) => void;
  rotationInterval: number;
  setRotationInterval: (interval: number) => void;
  autoScroll: boolean;
  setAutoScroll: (autoScroll: boolean) => void;
}

const SlideSettings: React.FC<SlideSettingsProps> = ({
  pages,
  setPages,
  onEditPage,
  rotationInterval,
  setRotationInterval,
  autoScroll,
  setAutoScroll,
}) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="pt-6">
          <div className="space-y-4">
            <div className="grid gap-2">
              <Label htmlFor="rotation-interval">זמן התחלפות בין שקופיות (בשניות)</Label>
              <Input
                id="rotation-interval"
                type="number"
                min={1}
                value={rotationInterval}
                onChange={(e) => setRotationInterval(Number(e.target.value))}
              />
            </div>
            
            <div className="flex items-center space-x-2">
              <Switch
                id="auto-scroll"
                checked={autoScroll}
                onCheckedChange={setAutoScroll}
              />
              <Label htmlFor="auto-scroll">גלילה אוטומטית בעמודים ארוכים</Label>
            </div>
          </div>
        </CardContent>
      </Card>
      
      {pages && pages.length > 0 && (
        <div className="space-y-2">
          <h3 className="text-lg font-medium">סדר תצוגת העמודים</h3>
          <div className="space-y-2">
            {pages.map((page) => (
              <Card key={page.id}>
                <CardContent className="p-4 flex justify-between items-center">
                  <div>
                    <h4 className="font-medium">{page.name || page.title}</h4>
                    <p className="text-sm text-gray-500">{page.type}</p>
                  </div>
                  <Button variant="outline" onClick={() => onEditPage(page.id)}>
                    ערוך
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SlideSettings;
